@if (gridModel) {
  <!-- For loop trick with tracking by viewId is used to re-render virtual scroll component in case when grid view id changes -->
  @for (item of [gridModel.viewId]; track item) {
    @if (calculatedTableData) {
      <div
        #headerRow
        class="grid-header-row w-full overflow-hidden flex pr-2 relative"
        [style.height.px]="calculatedTableData?.columns[0]?.heightPx"
      >
        @for (columnIndex of (visibleColumnIndicies || []); track columnIndex) {
          <div
            class="grid-header-column grid-column grid-column-index-{{ columnIndex }} flex gap-2 absolute top-0 h-full"
            [attr.data-test-id]="'header-cell-' + columnIndex"
            [style.min-width]="
              calculatedTableData?.columns[columnIndex] ? calculatedTableData.columns[columnIndex].widthPx + 'px' : 'inherit'
            "
            [style.max-width]="
              calculatedTableData?.columns[columnIndex] ? calculatedTableData.columns[columnIndex].widthPx + 'px' : 'inherit'
            "
            [style.left.px]="calculatedTableData?.columns[columnIndex]?.positionPx - scrollContainer.scrollLeft"
            [ngClass]="{
              'first-column': columnIndex === 0,
              'last-column': columnIndex === gridModel.columnsData.length - 1,
              'cursor-pointer': gridModel.columnsData[columnIndex]?.sortable,
              'selected-column': gridModel.columnsData[columnIndex]?.columnId === headerTemplateContext?.selectedColumnId
            }"
            (click)="headerClick(gridModel.columnsData[columnIndex])"
          >
            <ng-container
              *ngTemplateOutlet="
                headerCellWrapperTemplate;
                context: {
                  column: gridModel.columnsData[columnIndex],
                  columnIndex: columnIndex,
                  isFirst: columnIndex === 0,
                  isLast: columnIndex === gridModel.columnsData.length - 1
                }
              "
            ></ng-container>
          </div>
        }
      </div>
    }

    @if (!gridModel.subRows.length) {
      <div class="flex flex-col h-full border rounded-md">
        <div class="flex flex-col items-center justify-center text-center px-4 h-full">
          <svg-icon class="w-8 h-8 mb-2" [src]="'status_complete'"></svg-icon>
          <p class="text-base font-bold m-0 text-navy-90">{{ emptyTableText.title }}</p>
          <p class="text-lg text-navy-70 mt-1">{{ emptyTableText.description }}</p>
        </div>
      </div>
    }
    <div
      #scrollContainer
      scrollButtons
      class="flex-1 scrollable-container h-full"
      [ngClass]="{
        'overflow-auto': !gridModel.loading,
        'overflow-hidden': gridModel.loading
      }"
      (scroll)="scrollContainerScrolled(scrollContainer)"
    >
      <virtual-scroller
        #virtualScroller
        class="h-full"
        [class.invisible]="!calculatedTableData"
        [parentScroll]="scrollContainer"
        [items]="gridModel.subRows"
        [enableUnequalChildrenSizes]="false"
        [bufferAmount]="30"
        [scrollDebounceTime]="0"
        [scrollThrottlingTime]="0"
        [checkResizeInterval]="0"
        (vsChange)="onVsStart($event)"
      >
        @for (splittedRow of virtualScroller.viewPortItems; track splittedRow?.id; let rowIndex = $index) {
          <div
            class="flex flex-row min-w-full relative"
            [style.width.px]="calculatedTableData?.widthPx"
            [ngClass]="getSubrowClasses(splittedRow)"
          >
            @if (splittedRow.subRowType === subRowTypeEnum.Data) {
              @for (columnIndex of visibleColumnIndicies; track columnIndex) {
                <div
                  class="grid-column grid-column-index-{{ columnIndex }} flex h-full w-full overflow-hidden absolute"
                  [style.min-width.px]="calculatedTableData?.columns[columnIndex]?.widthPx"
                  [style.max-width.px]="calculatedTableData?.columns[columnIndex]?.widthPx"
                  [style.left.px]="calculatedTableData?.columns[columnIndex]?.positionPx"
                  [ngClass]="{
                    'first-column': columnIndex === 0,
                    'last-column': columnIndex === gridModel.columnsData.length - 1,
                    'flex-1': gridModel.loading,
                    'last-row': splittedRow.index === gridModel.subRows.length - 1,
                    'selected-column': gridModel.columnsData[columnIndex]?.columnId === headerTemplateContext?.selectedColumnId,
                  }"
                >
                  @if (splittedRow.loading) {
                    <ng-container *ngTemplateOutlet="skeletonTemplate"></ng-container>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="
                                    rowCell;
                                    context: { subrow: splittedRow, columnIndex: columnIndex }
                                  "
                    ></ng-container>
                  }
                </div>
              }
            } @else if (splittedRow.subRowType === subRowTypeEnum.ExpandCollapse) {
              <div
                class="absolute h-full flex flex-row items-center justify-center divide-x font-bold cursor-pointer underline"
                [ngClass]="{ 'skeleton-cell': splittedRow.loading }"
                [style.width.px]="scrollContainer.clientWidth"
                [style.left.px]="scrollContainer.scrollLeft"
              >
                @if (splittedRow.hiddenChunksCount >= 1) {
                  <span class="px-1" (click)="showMoreClick(splittedRow)">Show more</span>
                }
                @if (splittedRow.displayedChunksCount > 1) {
                  <span class="px-1" (click)="showLessClick(splittedRow)">Show Less</span>
                }
                @if (splittedRow.displayedChunksCount > 1 && splittedRow.hiddenChunksCount > 0) {
                  <span class="px-1" (click)="showAllClick(splittedRow)">Show All</span>
                }
                @if(splittedRow.displayedChunksCount > 2 && splittedRow.hiddenChunksCount === 0) {
                  <span class="px-1" (click)="hideAllClick(splittedRow)">Hide All</span>
                }
              </div>
            }
          </div>
        }
      </virtual-scroller>
    </div>
  }
  @if (!calculatedTableData) {
    <div class="column-width-calculation-table grid absolute top-0 left-0 min-w-full min-h-full" [style.grid-template-columns]="getGridTemplateColumnStyle()">
      @for (column of gridModel.columnsData; track column; let isFirst = $first; let isLast = $last; let index = $index)
      {
        <div
          class="grid-header-column grid-column flex gap-2"
          [ngClass]="{
            'first-column': isFirst,
            'last-column': isLast
          }"
        >
          <ng-container
            *ngTemplateOutlet="
              headerCellWrapperTemplate;
              context: { column: column, index: index, isFirst: isFirst, isLast: isLast }
            "
          ></ng-container>
        </div>
      }

      @for (splittedRow of sampleSubRows; track splittedRow?.rowId; let rowIndex = $index) {
        @for (column of gridModel.columnsData; track column.columnId; let isFirst = $first; let isLast = $last; let
        cellIndex = $index) {
          <div
            class="grid-column flex"
            [class.first-column]="isFirst"
            [class.last-column]="isLast"
          >
            <ng-container
              *ngTemplateOutlet="
                        rowCell;
                        context: { subrow: splittedRow, columnIndex: cellIndex }
                      "
            ></ng-container>
          </div>
        }
      }
    </div>
  }
}

<ng-template #headerCell let-isFirst="isFirst" let-isLast="isLast" let-cellValue="cellValue" let-columnId="columnId">
  <ng-container
    *ngTemplateOutlet="
      headerTemplate || defaultHeaderCell;
      context: {
        isFirst: isFirst,
        isLast: isLast,
        cellValue: cellValue,
        sorted: cellValue === (sortInfo$ | async).sortColumn,
        sortDirection: (sortInfo$ | async).sortDirection?.toUpperCase(),
        onRadioToggled: headerTemplateContext?.onRadioToggled,
        columnId: columnId,
        selectedColumnId: headerTemplateContext?.selectedColumnId
      }
    "
  ></ng-container>
</ng-template>

<ng-template #rowCell let-subrow="subrow" let-columnIndex="columnIndex">
  <ng-container
    *ngTemplateOutlet="
      cellTemplate || defaultRowCell;
      context: getCellContext(subrow, columnIndex)
    "
  ></ng-container>
</ng-template>

<ng-template #defaultHeaderCell let-isFirst="isFirst" let-isLast="isLast" let-cellValue="cellValue">
  <span>{{ cellValue }}</span>
</ng-template>
<ng-template #defaultRowCell let-isFirst="isFirst" let-isLast="isLast" let-cellValue="cellValue">
  <span>{{ cellValue }}</span>
</ng-template>

<ng-template #skeletonTemplate><div class="flex-1 skeleton-cell max-h-4"></div></ng-template>

<ng-template #headerCellWrapperTemplate let-column="column" let-index="index" let-isFirst="isFirst" let-isLast="isLast">
  @if (!gridModel.loading) {
    <ng-container
      *ngTemplateOutlet="
        headerCell;
        context: {
          isFirst: isFirst,
          isLast: isLast,
          cellValue: column?.columnName,
          columnId: column?.columnId
        }
      "
    ></ng-container>
    @if (column?.columnDescription) {
      <app-info-icon
        class="info-wrapper relative pt-px top-px"
        [tooltipPosition]="'right top-right'"
        [tooltipText]="column.columnDescription | translate"
      ></app-info-icon>
    }

    @if (sortInfo$ | async; as sortInfo) {
      @if (column?.sortable && sortInfo?.sortColumn === column?.columnId) {
        <svg-icon
          class="transform text-white"
          [ngClass]="{
            'rotate-180': sortInfo.sortDirection === 'desc',
          }"
          [src]="'arrow-single'"
        ></svg-icon>
      }
    }
  } @else {
    <ng-container *ngTemplateOutlet="skeletonTemplate"></ng-container>
  }
</ng-template>
